import { isValidPhoneNumber as isValid, type CountryCode } from 'libphonenumber-js'

import { LOCALE, type Locale } from '@/legacy-src/constants/locale.constants'

const countryCodeMap: Record<Locale, CountryCode | undefined> = {
  en: undefined,
  cs: 'CZ',
  ro: 'RO',
  pl: 'PL',
  sk: 'SK',
  el: 'GR',
  hu: 'HU',
  uk: 'UA',
  sl: 'SI',
  lt: 'LT',
}

export const isValidPhoneNumber = (...args: Parameters<typeof isValid>): boolean => {
  const text = args[0]

  const options =
    typeof args[1] === 'object'
      ? args[1]
      : typeof args[1] === 'string'
        ? {
            defaultCountry: args[1],
          }
        : {}

  const isValidNumber = isValid(text, {
    defaultCountry: countryCodeMap[LOCALE],
    ...options,
  })

  return isValidNumber
}
